var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.22168,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D1FADF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_13927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 15.6079V16.2213C22.6658 17.6589 22.2003 19.0577 21.3395 20.2091C20.4787 21.3606 19.2688 22.2029 17.8902 22.6105C16.5115 23.0181 15.0381 22.9692 13.6896 22.471C12.341 21.9728 11.1897 21.052 10.4072 19.846C9.62476 18.64 9.25311 17.2133 9.3477 15.7788C9.44229 14.3443 9.99806 12.9788 10.9321 11.886C11.8662 10.7931 13.1284 10.0315 14.5307 9.71469C15.933 9.39787 17.4001 9.54282 18.7133 10.1279M22.6666 10.8879L15.9999 17.5613L13.9999 15.5613",
    stroke: "#039855",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_13927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8.22168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApprove);
export default __webpack_public_path__ + "static/media/icon-approve.2777b76bfd263bfc9ce42cacb27beb23.svg";
export { ForwardRef as ReactComponent };